import {type FeatureFlags} from "./types.ts";

/**
 * Parse a flags cookie value.
 *
 * Parses the cookie value into an object.
 *
 * @param rawCookie - The raw cookie string to parse.
 * @returns An object mapping flag names to their boolean values.
 */
export function parseFlagsCookie(rawCookie: string): FeatureFlags {
    // The cookie is URI encoded when set.
    const cookie = decodeURIComponent(rawCookie);

    const [flagsOnString, flagsOffString] =
        cookie.indexOf("|") !== -1 ? cookie.split("|") : [cookie, ""];

    const flagsOn = flagsOnString.split("\n").filter((f) => f !== "");
    const flagsOff = flagsOffString.split("\n").filter((f) => f !== "");

    const result: Record<string, boolean> = {};
    flagsOn.forEach((f) => (result[f] = true));
    flagsOff.forEach((f) => (result[f] = false));
    return result;
}
